import React, {useRef, useState} from "react";
import CsvFileUploader from "../Common/CsvFileUploader";
import { Modal} from "react-bootstrap";
import {toast} from "react-toastify";


const UploadCodesModal = ({ show, onClose, onUpload }) => {
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);
    const handleValidFile = (file) => {
        setSelectedFile(file);
    };

    const handleUploadClick = () => {
        if (!selectedFile) {
            toast.error("Please upload a CSV file before submitting.");
            return;
        }
        onUpload(selectedFile);
        setSelectedFile(null);
    };
     if (!show) return null;

    return (
        <Modal
            className="modal fade"
            size="l"
            show={show}
            onHide={onClose}
        >
            <div role="document">
                <form>
                    <div className="modal-header">
                        <h4 className="modal-title fs-20">Upload Campaign Codes</h4>
                    </div>
                    <div className="modal-body">
                        <i className="flaticon-cancel-12 close"></i>
                        <div className="add-contact-box">
                            <div className="add-contact-content">
                                <div className="row">
                                    <CsvFileUploader
                                        label="Select your CSV file"
                                        exampleLink="files/campaign_codes_template.csv"
                                        inputRef={fileInputRef}
                                        onValidFile={handleValidFile}
                                        height="3rem"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={handleUploadClick} disabled={!selectedFile}>
                            Add
                        </button>
                        <button className="btn btn-warning" onClick={onClose}>
                            Discard
                        </button>
                    </div>
                </form>
            </div>
        </Modal>

    );
};

export default UploadCodesModal;
